var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7282 11.0525L19.3742 9.41186C18.9477 9.11463 18.3582 9.4173 18.3582 9.93267V10.9361H7.05571C6.69975 10.9361 6.41113 11.2214 6.41113 11.5734C6.41113 11.9253 6.69975 12.2106 7.05571 12.2106H18.3581V13.214C18.3581 13.7327 18.9507 14.0298 19.3741 13.7348L21.728 12.0941C22.0875 11.8438 22.0948 11.3086 21.7282 11.0525Z",
    fill: "#0083EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4968 15.6649C18.1888 15.4888 17.7944 15.5927 17.6161 15.8974C16.1021 18.4851 13.2718 20.2223 10.0376 20.2223C5.2137 20.2223 1.28911 16.3424 1.28911 11.5733C1.28911 6.80429 5.2137 2.92434 10.0376 2.92434C13.274 2.92434 16.1029 4.66317 17.6161 7.24918C17.7943 7.55385 18.1888 7.65779 18.4968 7.48172C18.8049 7.30551 18.9102 6.91567 18.732 6.61105C16.9906 3.63499 13.7384 1.6499 10.0376 1.6499C4.4898 1.6499 0 6.08816 0 11.5733C0 17.058 4.48933 21.4968 10.0376 21.4968C13.7399 21.4968 16.9914 19.5103 18.732 16.5355C18.9102 16.2309 18.8049 15.8411 18.4968 15.6649Z",
    fill: "#0083EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21.7497,
    fill: "white",
    transform: "translate(0 0.698486)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.f775fb15668efb82e0df92ce7806f3f8.svg";
export { ForwardRef as ReactComponent };